exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointSiteCard_2n71739pTywGrBwt1fwN-M{\n  display:flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.IA_sharePointSiteWrapper_3cLSWgb_LvCaGfxt6KsOXZ {\n  font-size: 14px;\n  float: left;\n  display: block;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.IA_sharePointSiteId_pwvRe9EphF_Hl_a7kT_8k {\n  font-size: 9px;\n  opacity: 0.8\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointSiteCard": "IA_sharePointSiteCard_2n71739pTywGrBwt1fwN-M",
	"IA_sharePointSiteWrapper": "IA_sharePointSiteWrapper_3cLSWgb_LvCaGfxt6KsOXZ",
	"IA_sharePointSiteId": "IA_sharePointSiteId_pwvRe9EphF_Hl_a7kT_8k"
};